/**selfWorkOrder
 * 自检store
 */
// import { message } from 'ant-design-vue'
let store = {
  state: {
    //当前待自检工单
    selfWorkOrder: null,
    //检验记录列表
    selfRecordList: [],
    //自检sip列表
    selfSipList: [],
    //当前选中自检sip文档的id
    currSelfSipId: null,
    //表单
    selfInspectFormData: {
      batchCode: undefined
    }
  },
  mutations: {
    setSelfWorkOrder(state, selfWorkOrder){
      state.selfWorkOrder = selfWorkOrder
    },
    setSelfRecordList(state, selfRecordList){
      state.selfRecordList = selfRecordList
    },
    setSelfSipList(state, selfSipList){
      state.selfSipList = selfSipList
    },
    setCurrSelfSipId(state, currSelfSipId){
      state.currSelfSipId = currSelfSipId
    },
  },
  actions:{
    // 检查是否存在检验工单
    // async waitInspectBySheetExist({state}){
    //   if(!state.waitInspectBySheet){
    //     message.warn("请先选中待检工单!")
    //     return false
    //   }
    //   return true
    // },
    // 新增检验记录
    addSelfRecord(){
      // state.selfRecordList.push()
    },
    // 删除检验记录
    delSelfRecord({state, getters}, key){
      state.selfRecordList.splice(getters.getSelfRecordList.findIndex(item => item.key == key), 1)
    },
    // 重置检验相关数据
    resetSelfInspectDatas(placeholder, {recordList}){
      this.commit('setSelfRecordList', recordList)
    },
    // 上一个或者下一个文件 next 1：下一个文件  -1：上一个文件
    nextSipDoc({state}, next){
      let selfSipList = state.selfSipList
      if(!selfSipList || selfSipList.length < 1) return
      //当前下标
      let currIndex = selfSipList.findIndex(item => item.id == state.currSelfSipId)
      currIndex += next
      if(currIndex < 0) currIndex = 0
      let maxIndex  = selfSipList.length - 1
      if(currIndex > maxIndex) currIndex = maxIndex
      this.commit('setCurrSelfSipId', selfSipList[currIndex].id)
    }
  },
  getters:{
    // 获取当前自检工单
    getSelfWorkOrder(state){
      return state.selfWorkOrder
    },
    // 获取当前自检工单id
    getSelfWorkOrderId(state){
      return state.selfWorkOrder?.id
    },
    // 获取检验记录列表
    getSelfRecordList(state){
      state.selfRecordList || (state.selfRecordList = [])
      return state.selfRecordList
    },
    getCurrSelfSipDoc(state){
      let doc = state.selfSipList.find(item => item.id == state.currSelfSipId)
      return doc
    }
  }
}

export default {
  ...store
}
